import ProfileSidebar from "../components/layout/ProfileSidebar";
import Header from "../components/layout/Header";
import GamesView from "../components/layout/GamesView";
import { Helmet } from "react-helmet";

export default function AllGames() {

  return (
    <div className="pageStandard">
      <Helmet>
        <title>alle spil | matly</title>
      </Helmet>
      <Header />
      <div className="contentRow">
        <GamesView />
      </div>
    </div>
  );
}